export default __webpack_public_path__ + "static/panel-bg-01-3-63b6c311330536ac3a315b791cf01b7e.png";